import React, { useEffect } from "react";
import "./prototypeEmbed.css";

const PrototypeEmbed = ({ source, title }) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <main className="prototype-page">
      <iframe
        className="prototype-frame"
        src={source || "about:blank"}
        title={title}
        allowFullScreen
      />
    </main>
  );
};

export default PrototypeEmbed;
